import React from "react";
import socialLinks from '../../utils/socialLinks';
const ClientFooter = () => {
    return (
        <>

            <footer id="footer" className="rbt-footer footer-style-1 bg-color-white overflow-hidden">
                <div className="footer-top">
                    <div className="container">
                        <div className="row g-5">
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="footer-widget">
                                    <div className="logo">
                                        <a href="index.html">
                                            <img src="assets1/images/logo/logo.png" alt="Edu-cause" />
                                        </a>
                                    </div>
                                    <p className="description mt--20">
                                        We’re always in search for talented and motivated people. Don’t
                                        be shy introduce yourself!
                                    </p>
                                    <ul className="social-icon social-default justify-content-start">
                                        <li>
                                            <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                                                <i className="feather-facebook" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                                                <i className="feather-twitter" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                                                <i className="feather-instagram" />
                                            </a>
                                        </li>
                                        <li>
                                            <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                                                <i className="feather-youtube" />
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="contact-btn mt--30">
                                        <a
                                            className="rbt-btn hover-icon-reverse btn-border-gradient radius-round"
                                            href="#"
                                        >
                                            <div className="icon-reverse-wrapper">
                                                <span className="btn-text">Contact With Us</span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                                <span className="btn-icon">
                                                    <i className="feather-arrow-right" />
                                                </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="footer-widget">
                                    <h5 className="ft-title">Useful Links</h5>
                                    <ul className="ft-link">
                                        <li>
                                            <a href="/Faq">FAQ</a>
                                        </li>
                                        <li>
                                            <a href="/TermsAndConditions">Terms And Conditions</a>
                                        </li>
                                        <li>
                                            <a href="/PrivacyPolicy">Privacy policy</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-6 col-sm-6 col-12">
                                <div className="footer-widget">
                                    <h5 className="ft-title">Our Company</h5>
                                    <ul className="ft-link">
                                        <li>
                                            <a href="/RefundPolicy">Refund Policy</a>
                                        </li>
                                        <li>
                                            <a href="/TradingRiskDisclaimer">Trading Risk Disclaimer</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="footer-widget">
                                    <h5 className="ft-title">Get Contact</h5>
                                    <ul className="ft-link">
                                        <li>
                                            <span>Phone:</span> <a href="#">(+91)-7808780874</a>
                                        </li>
                                        <li>
                                            <span>E-mail:</span>{" "}
                                            <a href="mailto:hr@example.com">venkateshan@daytradingtactics.in</a>
                                        </li>
                                    </ul>
                                    <form className="newsletter-form mt--20" action="#">
                                      
                                        <div className="form-group right-icon icon-email mb--20">
                                            <label htmlFor="email">Enter Your Email Here</label>
                                            <input id="email" type="email" />
                                        </div>
                                        <div className="form-group mb--0">
                                            <button
                                                className="rbt-btn rbt-switch-btn btn-gradient radius-round btn-sm"
                                                type="submit"
                                            >
                                                <span data-text="Submit Now">Submit Now</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rbt-separator-mid">
                    <div className="container">
                        <hr className="rbt-separator m-0" />
                    </div>
                </div>
                {/* Start Copyright Area  */}
                <div className="copyright-area copyright-style-1 ptb--20">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
                                <p className="rbt-link-hover text-center text-lg-start">
                                    Copyright © 2025{" "}
                                    <a href="/">
                                     Day Trading Tactics
                                    </a>{" "}
                                    All Rights Reserved
                                </p>
                            </div>
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-12">
                                <ul className="copyright-link rbt-link-hover justify-content-center justify-content-lg-end mt_sm--10 mt_md--10">
                                    <li>
                                        <a href="/TermsAndConditions">Terms of service</a>
                                    </li>
                                    <li>
                                        <a href="/PrivacyPolicy">Privacy policy</a>
                                    </li>
                                    <li>
                                        <a href="/RefundPolicy">Refund Policy</a>
                                    </li>
                                    <li>
                                        <a href="/StudentLogin">Login &amp; Register</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Copyright Area  */}
            </footer>
        </>
    );
};

export default ClientFooter;
